import styled from '@emotion/styled';

import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { WorkWithUsData } from './WorkWithUsData';
import ComponentHeader from '../../../components/ComponentHeader/ComponentHeader';
import SimpleCard from '../../../components/Card/SimpleCard';

const WorkWithUs = () => {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.1,
  });

  return (
    <Container className='intersection-animate'>
      <ComponentHeader text="Work With Us Today!" />
      <CardRow>
        {WorkWithUsData.map((data, index) => (
          <SimpleCard
            key={index}
            icon={data.imageName}
            text={data.description}
          />
        ))}
      </CardRow>
    </Container>
  );
};

export default WorkWithUs;

const Container = styled.div`
  padding-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  gap: 40px;

  &.animate {
    --ydist: 100%;

    & > * {
      animation-duration: 0.3s;
      animation-delay: 0.3s;
      animation-timing-function: ease-out;
      animation-fill-mode: backwards;
    }

    & > *:first-of-type {
      animation-name: header-translate, text-opacity;
      animation-delay: 0.5s;
    }

    & > *:last-of-type {
      --ydist: 50%;
      animation-name: header-translate;
    }

    @keyframes header-translate {
      from {
        transform: translateY(var(--ydist));
      }
      to {
        transform: 0;
      }
    }

    @keyframes text-opacity {
      from {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }

  @media (max-width: 884px) {
    align-items: center;
    padding-bottom: 55px;
  }
`;

const CardRow = styled.div`
width: 100%;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr;
  place-items: center
  overflow: hidden;

  @media (max-width: 884px) {
    flex-direction: column;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 24px;
  }
`;


